import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { TourProvider } from "./components/tour/TourContext";
import LandingPage from './pages/LandingPage'
import CurriculumPage from './pages/CurriculumPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import TutionPage from './pages/TutionPage';

const App = () => {
  return (
    <BrowserRouter basename="/">
      <TourProvider>
        <Routes>
          <Route path="/" element={<LandingPage />}/>
          <Route path="curriculum" element={<CurriculumPage />}/>
          <Route path="contact" element={<ContactPage />}/>
          <Route path="about" element={<AboutPage />}/>
          <Route path="tuition" element={<TutionPage />}/>
          <Route path="*" element={<LandingPage />}/>
        </Routes>
      </TourProvider>
      <ScrollToTop />
    </BrowserRouter>
  )
}

export default App
